import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Alert } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";

const { Option } = Select;

const formItemLayout = {
  labelCol: { xs: { span: 24 }, md: { span: 24 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, md: { span: 24 }, lg: { span: 12 } },
};

const MaterialCategoryUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  // STATE'LER
  const [level1Categories, setLevel1Categories] = useState([]); // Ana Kategoriler
  const [level2Categories, setLevel2Categories] = useState([]); // Alt Kategoriler

  // UX: Seçili olan ID'yi tutalım ki 2. kutuyu açalım
  const [selectedLevel1Id, setSelectedLevel1Id] = useState(null);

  // Bilgi mesajı için
  const [currentLevelText, setCurrentLevelText] = useState("Yükleniyor...");

  // Kategori Listesi Çekme
  const getCategories = (parentId, level) => {
    let filter = "";
    if (level === 1) {
      filter = "ParentId eq null";
    } else {
      if (!parentId) return;
      filter = `ParentId eq ${parentId}`;
    }

    // Promise dönüyoruz ki zincirleme işlem yapabilelim
    return RequestHandler.get(
      `/MaterialCategory?$filter=${filter}`
    ).then((response) => {
      if (response) {
        if (level === 1) setLevel1Categories(response.value);
        if (level === 2) setLevel2Categories(response.value);
      }
      return response;
    });
  };

  // Tekil Kategori Detayı Çekme (Hiyerarşiyi çözmek için)
  const getCategoryDetail = (id) => {
    return RequestHandler.get(`/MaterialCategory/GetById/${id}`);
  };

  useEffect(() => {
    if (props.data) {
      // 1. Temel alanları doldur (Name, Code, Id)
      form.setFieldsValue({
        id: props.data.id,
        name: props.data.name,
        code: props.data.code,
      });

      // 2. Hiyerarşiyi Çöz ve Selectboxları Doldur
      resolveHierarchy(props.data);
    }
  }, [props.data]);

  const resolveHierarchy = async (currentData) => {
    // Adım 1: Her halükarda Level 1 listesini doldur
    await getCategories(null, 1);

    // Eğer Parent yoksa -> Bu bir Ana Kategoridir (Seviye 1)
    if (!currentData.parentId) {
      setCurrentLevelText("Kategori (Seviye 1)");
      return;
    }

    // Eğer Parent varsa, o Parent'ın detayına bakmamız lazım (Dede var mı?)
    const parentResponse = await getCategoryDetail(currentData.parentId);


    if (parentResponse) {
      const parentCat = parentResponse;

      if (parentCat.parentId) {
        // --- SENARYO: DETAY KATEGORİ (SEVİYE 3) ---
        // Parent'ın da Parent'ı var (Dede).
        // 1. Kutu: Dede (parentCat.parentId)
        // 2. Kutu: Baba (currentData.parentId)

        setSelectedLevel1Id(parentCat.parentId); // 2. kutuyu görünür yap

        // Önce Dede'ye bağlı Alt Kategorileri çek (Level 2 listesini doldur)
        await getCategories(parentCat.parentId, 2);

        // Formu doldur
        form.setFieldsValue({
          level1Id: parentCat.parentId,
          level2Id: currentData.parentId,
        });

        setCurrentLevelText("Alt Kategori (Seviye 3)");
      } else {
        // --- SENARYO: ALT KATEGORİ (SEVİYE 2) ---
        // Parent'ın Parent'ı yok.
        // 1. Kutu: Baba (currentData.parentId)
        // 2. Kutu: Boş

        setSelectedLevel1Id(currentData.parentId); // 2. kutuyu görünür yap

        // Baba seçili olduğu için, babanın altlarını (Level 2 listesi) yine de çekelim
        // (Belki kullanıcı bu kategoriyi başka birinin altına taşımak ister)
        await getCategories(currentData.parentId, 2);

        // Formu doldur
        form.setFieldsValue({
          level1Id: currentData.parentId,
          level2Id: null,
        });

        setCurrentLevelText("Ana Kategori (Seviye 2)");
      }
    }
  };

  // 1. Kutu Değişince
  const handleLevel1Change = (value) => {
    setSelectedLevel1Id(value);
    setLevel2Categories([]); // Alt listeyi temizle
    form.setFieldsValue({ level2Id: null }); // Seçimi temizle

    if (value) {
      // Kendisini kendi parent'ı yapamasın kontrolü (Basitçe)
      if (value === props.data.id) {
        // UI'da engellemek daha şık olur ama burada basit logic
        // Backend zaten circular dependency hatası verir.
      }

      getCategories(value, 2);
      setCurrentLevelText("Ana Kategori (Seviye 2) Olacak");
    } else {
      setCurrentLevelText("Kategori (Seviye 1) Olacak");
    }
  };

  // 2. Kutu Değişince
  const handleLevel2Change = (value) => {
    if (value) {
      setCurrentLevelText("Alt Kategori (Seviye 3) Olacak");
    } else {
      // Üstü seçiliyse
      if (selectedLevel1Id)
        setCurrentLevelText("Ana Kategori (Seviye 2) Olacak");
    }
  };

  const onFinish = (values) => {
    // Add formu ile aynı mantık
    let parentIdToSend = null;

    if (values.level2Id) {
      parentIdToSend = values.level2Id;
    } else if (values.level1Id) {
      parentIdToSend = values.level1Id;
    }

    // Kendisini kendisine parent yapmayı engelle (Frontend kontrolü)
    if (parentIdToSend === props.data.id) {
      // Notification veya hata
      // Antd form validasyonu ile de yapılabilir ama basitçe:
      return;
    }

    const finalValues = {
      id: props.data.id, // Update için ID şart
      name: values.name,
      code: values.code,
      ParentId: parentIdToSend,
    };

    setLoading(true);
    RequestHandler.put(`/MaterialCategory`, finalValues).then(
      (response) => {
        setLoading(false);
        if (response.success) {
          if (props.onSuccess) props.onSuccess();
        }
      }
    );
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="MaterialUpdate"
      onFinish={onFinish}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          {/* Bilgi Mesajı */}
          <Row justify="center" style={{ marginBottom: 20 }}>
            <Col span={20}>
              <Alert
                message={`Mevcut Durum: ${currentLevelText}`}
                type="warning"
                showIcon
              />
            </Col>
          </Row>

          {/* 1. SEVİYE SEÇİMİ */}
          <Form.Item label="Ana Kategori" name="level1Id">
            <Select
              placeholder="Yok (Ana Kategori Yap)"
              allowClear
              onChange={handleLevel1Change}
            >
              {level1Categories
                .filter((x) => x.id !== props.data?.id) // Kendisini listede gösterme
                .map((cat) => (
                  <Option key={cat.id} value={cat.id}>
                    {cat.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          {/* 2. SEVİYE SEÇİMİ */}
          {selectedLevel1Id && (
            <Form.Item label="Alt Kategori" name="level2Id">
              <Select
                placeholder="Yok (Alt Kategori Yap)"
                allowClear
                onChange={handleLevel2Change}
                disabled={level2Categories.length === 0}
              >
                {level2Categories
                  .filter((x) => x.id !== props.data?.id) // Kendisini listede gösterme
                  .map((cat) => (
                    <Option key={cat.id} value={cat.id}>
                      {cat.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            label="Kategori Adı"
            name="name"
            rules={[{ required: true, message: "Lütfen isim giriniz." }]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Kategori Kodu" name="code">
            <Input />
          </Form.Item>

          <Row justify="end">
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />} // Veya EditOutlined
                htmlType="submit"
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default MaterialCategoryUpdateForm;
